// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b552b540","159":"e9fa82b9","237":"e99efb7d","440":"06c1d8cd","441":"0ad8f24e","451":"adc49b0d","453":"c2989a97","525":"43c25dd0","572":"38951826","747":"83387d66","822":"6f9c361f","971":"6b35c244"}[chunkId] + ".chunk.js";
};